import { render, staticRenderFns } from "./en.vue?vue&type=template&id=4bc1345b&scoped=true&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"
import style0 from "./en.vue?vue&type=style&index=0&id=4bc1345b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1345b",
  null
  
)

export default component.exports